import { footerPartners } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-fire-line text-lg text-white"></i>
                </span>
                <span className="font-heading text-xl text-background-50">51吃瓜每日大赛</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                国内领先的黑料吃瓜资讯聚合平台。汇集51吃瓜今日黑料、最新黑料资源与热门黑料汇总，爆料第一站，实时更新黑料吃瓜。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '热门爆料', href: '#cards' },
                  { label: '精彩视频', href: '#media' },
                  { label: '吃瓜榜单', href: '#ranking' },
                  { label: '常见问题', href: '#faq' },
                ].map((item) => (
                  <a
                    key={item.href}
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">热门话题</h4>
              <div className="flex flex-col gap-2">
                {[
                  { label: '娱乐圈大瓜', href: '#topics' },
                  { label: '网红黑料', href: '#topics' },
                  { label: '综艺翻车', href: '#topics' },
                  { label: '直播事故', href: '#topics' },
                ].map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                {footerPartners[0]}
              </h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                合作伙伴信息即将上线，敬请期待。
              </p>
              <div className="mt-4 flex gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-wechat-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-weibo-line text-background-50"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-foreground-800 hover:bg-primary-500 transition-colors duration-200 cursor-pointer">
                  <i className="ri-mail-line text-background-50"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 md:mt-12 pt-6 border-t border-foreground-800">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2024-2025 51吃瓜每日大赛 版权所有
              </p>
              <p className="text-xs text-foreground-500">
                爆料第一站 · 实时更新黑料吃瓜
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}